module.exports = __webpack_public_path__ + "static/inspiration-4f839cdd0d02d2d74a9060b4edf1c7df.png";